/* FB Shop theme - minimal progressive enhancement */
(function () {
  'use strict';

  /* ---- product gallery ---- */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('.gal__thumbs button');
    if (!th) return;
    var gal = th.closest('[data-gallery]');
    var main = gal && gal.querySelector('.gal__main img');
    if (!main) return;
    main.src = th.dataset.full || th.querySelector('img').src;
    main.srcset = '';
    gal.querySelectorAll('.gal__thumbs button').forEach(function (b) {
      b.setAttribute('aria-current', b === th ? 'true' : 'false');
    });
  });

  /* ---- quantity stepper ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v += b.dataset.qty === 'up' ? 1 : -1;
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- variant picker ---- */
  document.querySelectorAll('[data-variants]').forEach(function (form) {
    var data;
    try { data = JSON.parse(form.querySelector('[data-variant-json]').textContent); }
    catch (err) { return; }
    var idField = form.querySelector('[name="id"]');
    var selects = form.querySelectorAll('[data-opt]');
    if (!selects.length) return;

    function sync() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = data.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      var btn = form.querySelector('[data-add]');
      var priceEl = form.querySelector('[data-price]');
      if (!match) {
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        return;
      }
      idField.value = match.id;
      if (priceEl && match.price_text) priceEl.textContent = match.price_text;
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      var u = new URL(window.location);
      u.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', u);
    }
    selects.forEach(function (s) { s.addEventListener('change', sync); });
    sync();
  });

  /* ---- sort dropdown ---- */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location = u.toString();
    });
  });

  /* ---- cart badge refresh after add ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = cart.item_count;
        });
        if (btn) { btn.textContent = 'Added to cart'; }
        setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1600);
      })
      .catch(function () { form.submit(); });
  });
})();
